import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

// Menu item type
interface MenuItem {
	key: string;
	label: string;
	icon: React.ReactNode;
	route: string;
	children?: MenuItem[];
}

interface SidebarMenuItemProps {
	item: MenuItem;
	level?: number;
	isExpanded: boolean;
	isActive: boolean;
	hasActiveChild: boolean;
	onClick: () => void;
	toggleMenu: (key: string) => void;
	renderChildren?: (children: MenuItem[], parentKey: string) => React.ReactNode;
}

/** 12px label + 13px×2 padding (px avoids :root 80% rem shrink). */
const SIDEBAR_MENU_ITEM_BASE =
	"flex min-h-[47px] w-full items-center gap-3 rounded-none border-b border-white/40 px-[18px] py-[13px] font-sans text-[12px] font-normal whitespace-nowrap transition focus:outline-none";

const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
	item,
	level = 0,
	isExpanded,
	isActive,
	hasActiveChild,
	onClick,
	// toggleMenu,
	renderChildren,
}) => {
	const hasChildren = Boolean(item.children?.length);

	const childBase = SIDEBAR_MENU_ITEM_BASE;
	const childInactive = "text-white/75 hover:bg-white/10";
	const childActive = "sidebar-item--active font-semibold !rounded-none";

	const parentBase = SIDEBAR_MENU_ITEM_BASE;
	const parentActive = "sidebar-item--active font-semibold text-white !rounded-none";
	const parentInactive = "text-white/85 hover:bg-white/10";

	return (
		<li key={item.key}>
			<div className="relative">
				<button
					type="button"
					onClick={onClick}
					className={
						level > 0
							? `${childBase} ${isActive ? childActive : childInactive}`
							: `${parentBase} ${isActive || hasActiveChild ? parentActive : parentInactive}`
					}>
					<span className="flex shrink-0 items-center [&>svg]:text-[1.375rem]">{item.icon}</span>
					<span className="flex-1 text-left text-[12px] leading-none">{item.label}</span>
					{hasChildren &&
						(isExpanded ? <ExpandLessIcon sx={{ fontSize: "1.125rem" }} /> : <ExpandMoreIcon sx={{ fontSize: "1.125rem" }} />)}
				</button>
			</div>
			{hasChildren && isExpanded && renderChildren && (
				<ul className="space-y-0 mt-0">{renderChildren(item.children ?? [], item.key)}</ul>
			)}
		</li>
	);
};

export default SidebarMenuItem;
